module.exports = __webpack_public_path__ + "media/images/icons/caret-left-9c765a4fe893094c7714f81a4f6af752.svg";